import { ReactNode } from 'react';
import { Box } from '@simplywallst/ui-core';
import { FadeIn, ScaleIn } from './styled';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Front } from './components/Front';
import { Back } from './components/Back';
import { SideToggleButton } from './components/SideToggleButton';
import { BackgroundImage } from './components/BackgroundImage';
import { TileSideToggleProvider } from './TileSideToggleContext';

export type Props = {
  children: ReactNode;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
};

export const Tile = ({ onMouseOver, onMouseOut, children }: Props) => {
  return (
    <Box
      position="relative"
      borderRadius="x1"
      boxShadow="subtleBorder"
      onMouseOver={() => {
        onMouseOver?.();
      }}
      onMouseOut={() => {
        onMouseOut?.();
      }}
      overflow="hidden"
    >
      <TileSideToggleProvider>{children}</TileSideToggleProvider>
    </Box>
  );
};

Tile.Header = Header;
Tile.Footer = Footer;
Tile.Front = Front;
Tile.Back = Back;
Tile.BackgroundImage = BackgroundImage;
Tile.ScaleInAnimation = ScaleIn;
Tile.FadeInAnimation = FadeIn;
Tile.SideToggleButton = SideToggleButton;
